import React from 'react';
import '../../src/styles/topbarStyle.css';
import authService from '../services/loginService';

const Topbar = ({ toggleSidebar, isSidebarOpen }) => {
  const currentUser = authService.getCurrentUser();

  const getRoleText = () => {
    if (!currentUser || !currentUser.role) return 'Usuario';
    switch (currentUser.role) {
      case 'Admin':
        return 'Administrador';
      case 'SuperAdmin':
        return 'Super Administrador';
      case 'ClientService':
        return 'Servicio a cliente';
      default:
        return 'Usuario';
    }
  };

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button
          className="hamburger-button"
          onClick={toggleSidebar}
          aria-label="Toggle menu"
        >
          <div className={`hamburger ${isSidebarOpen ? 'hamburger-open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
        <h1 className="topbar-title">Sistema de Administración de Parqueo Públicos</h1>
      </div>

      <div className="topbar-right">
        <div className="user-info1">
          <span className="user-role">{getRoleText()}</span>
        </div>
      </div>
    </div>
  );
};

export default Topbar;